import React from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import moment from "moment";

import Button from '@mui/material/Button';
import leftarrow from "assets/images/arrow-right.png";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useState, useEffect, useContext } from "react";
import Context from "context/context";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { toast } from "react-toastify";
import FormControl from '@mui/material/FormControl';
import PoolPrepApis from "apis/panel/PoolPrepRoster/poolPrepRoster";
import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Autocomplete from '@mui/material/Autocomplete';

const AddPoolPrepRoster = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useContext(Context);
  const [region, setRegion] = useState("");
  const [practice, setPractice] = useState("");
  const [projectionDate, setProjectionDate] = useState(null);
  const [initialGoLiveDate, setInitialGoLiveDate] = useState(null);
  const [status, setStatus] = useState("");
  const [modality1, setModality1] = useState("");
  const [modality1Volume, setModality1Volume] = useState('')
  const [modality2, setModality2] = useState("");
  const [modality2Volume, setModality2Volume] = useState("");
  const [modality3, setModality3] = useState("");
  const [modality3Volume, setModality3Volume] = useState("");
  const [fullGoLiveDate, setFullGoLiveDate] = useState("");
  const [weekendsVraSupport, setWeekendsVraSupport] = useState("");
  const [weekdaysVraSupport, setWeekdaysVraSupport] = useState("");
  const [coverageStart, setCoverageStart] = useState(null);
  const [coverageEnd, setCoverageEnd] = useState(null);
  const [shiftPattern, setShiftPattern] = useState("");
  const [handledByVra, setHandledByVra] = useState("");
  const [handledByRp, setHandledByRp] = useState("");
  const [remarks, setRemarks] = useState("");
  const [vraEmployees, setVraEmployees] = useState([])
  const [practices, setPractices] = useState([])

  const { getAllVraRosterAPI } = getAllVraShiftAPIS();

  const { getAllPracticesAPI } = PoolPrepApis();


  const handleGetAllVraEmployees = async () => {
    try {
      let res = await getAllVraRosterAPI();
      setVraEmployees(res?.data?.vraMaster || []);
    }
    catch (err) { }
  };

  const handleGetAllPractices = async () => {
    try {
      let res = await getAllPracticesAPI();
      setPractices(res?.data?.RpPractices || []);
    } catch (err) { }
  };

  useEffect(() => {
    handleGetAllVraEmployees()
    handleGetAllPractices()
  }, [])

  const maxDate = new Date()

  const [errorFields, setErrorFields] = useState({

    region: false,
    practice: false,
    projectionDate: false,
    initialGoLiveDate: false,
    modality1: false,
    modality1Volume: false,
    modality2: false,
    modality2Volume: false,
    status: false,
    modality3: false,
    modality3Volume: false,
    fullGoLiveDate: false,
    coverageStart: false,
    coverageEnd: false,
    shiftPattern: false,
    handledByVra: false,
    handledByRp: false,

  });


  const { createPoolPrepRosterAPI } = PoolPrepApis()


  const handleSavePoolPrepRoster = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!region) errors.region = true;
    if (!practice) errors.practice = true;
    if (!modality1Volume) errors.modality1Volume = true;
    if (!modality1) errors.modality1 = true;
    if (!modality2) errors.modality2 = true;
    if (!modality2Volume) errors.modality2Volume = true;
    if (!modality3) errors.modality3 = true;
    if (!modality3Volume) errors.modality3Volume = true;
    // if (!projectionDate) errors.projectionDate = true;
    if (!status) errors.status = true;
    if (!initialGoLiveDate) errors.initialGoLiveDate = true;
    if (!shiftPattern) errors.shiftPattern = true;
    if (!fullGoLiveDate) errors.fullGoLiveDate = true;
    if (!coverageStart) errors.coverageStart = true;
    if (!coverageEnd) errors.coverageEnd = true;
    if (!handledByVra) errors.handledByVra = true;
    if (!handledByRp) errors.handledByRp = true;

    setErrorFields(errors);

    if (Object.keys(errors).length === 0) {


      let values = {

        region: region,
        practice: practice,
        modality1Volume: parseFloat(modality1Volume),
        modality1: modality1,
        modality2: modality2,
        modality2Volume: parseFloat(modality2Volume),
        modality3: modality3,
        modality3Volume: parseFloat(modality3Volume),
        status: status,
        weekendsVraSupport: parseFloat(weekendsVraSupport),
        weekdaysVraSupport: parseFloat(weekdaysVraSupport),
        shiftPattern: shiftPattern,
        handledByVra: handledByVra,
        handledByRp: handledByRp,
        coverageStart: coverageStart.format("hh:mm A"),
        coverageEnd: coverageEnd.format("hh:mm A"),
        remarks: remarks,

      };

      if (moment(projectionDate).isValid()) {
        values = {
          ...values,
          projectionDate: moment(projectionDate).format("YYYY-MM-DD"),
        };
      }
      if (moment(initialGoLiveDate).isValid()) {
        values = {
          ...values,
          initialGoLiveDate: moment(initialGoLiveDate).format(
            "YYYY-MM-DD"
          ),
        };
      }
      if (moment(fullGoLiveDate).isValid()) {
        values = {
          ...values,
          fullGoLiveDate: moment(fullGoLiveDate).format("YYYY-MM-DD"),
        };
      }


      dispatch({ type: "SET_LOADING", payload: true });

      const res = await createPoolPrepRosterAPI(values);


      if (res.status === 'Ok') {
        handleCancel()
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.success("Data Saved Successfully", { toast: "Data Saved Successfully" });
      }
      else {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Error: User already exists in the system");
      }

    }


  };

  const handleCancel = () => {
    handleReset()
    navigate("/panel/poolPrepRoster")
  }

 const handleNavigation = () => {
    navigate("/panel/poolPrepRoster")
  }


  const handleReset = () => {

    setRegion('')
    setPractice('')
    setModality1('')
    setModality1('')
    setModality2('')
    setModality3('')
    setModality1Volume('')
    setModality2Volume('')
    setModality3Volume('')
    setStatus('')
    setWeekdaysVraSupport('')
    setWeekendsVraSupport('')
    setShiftPattern('')
    setHandledByVra('')
    setHandledByRp('')
    setCoverageStart('')
    setCoverageEnd('')
    setRemarks('')
    setProjectionDate('')
    setInitialGoLiveDate('')
    setFullGoLiveDate('')

  }


  const handleRegionChange = (event) => {
    const input = event.target.value;
    setRegion(input);
  };

  const handleModality1VolumeChange = (event) => {
    const input = event.target.value;
    setModality1Volume(input);
  };

  const handleModality1Change = (event) => {
    const input = event.target.value;
    setModality1(input);
  };

  const handleModality2VolumeChange = (event) => {
    const input = event.target.value;
    setModality2Volume(input);
  };

  const handleModality2Change = (event) => {
    const input = event.target.value;
    setModality2(input);
  };

  const handleModality3VolumeChange = (event) => {
    const input = event.target.value;
    setModality3Volume(input);
  };

  const handleModality3Change = (event) => {
    const input = event.target.value;
    setModality3(input);
  };

  const handleFullGoLiveDateChange = (date) => {


    setFullGoLiveDate(date);

  };

  const handleWeekendsVraSupportChange = (event) => {
    const input = event.target.value;

    setWeekendsVraSupport(input);

  };

  const handleWeekdaysVraSupportChange = (event) => {
    const input = event.target.value;

    setWeekdaysVraSupport(input);

  };


  const handleInitialGoLiveDateChange = (date) => {
    setInitialGoLiveDate(date);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleShiftPatternChange = (event) => {
    setShiftPattern(event.target.value);
  };

  const handleHandledByRpChange = (event) => {
    setHandledByRp(event.target.value);
  };


  const handleProjectionDateChange = (date) => {

    setProjectionDate(date);
  };

  return (
    <div style={{ backgroundColor: "white", borderRadius: "5px", marginTop: "1%" }}>
      <Grid sx={{ pl: 1, pt: 2 }} >
        <div style={{ display: 'flex', alignItems: 'center', gap: "1%" }}>
          <div onClick={handleNavigation} style={{ cursor: 'pointer', alignItems: "center" }}>
            <img src={leftarrow} alt="Back" />
          </div>
          <div
            style={{
              fontFamily: "Inter",
              fontSize: '16px',
              fontWeight: '600',

              letterSpacing: '0.02em',
              textAlign: 'left',
              color: '#0070E9',
              alignItems: "center"
            }}
          >
            Add Pool Prep Roster
          </div>

        </div>
      </Grid>

      <Grid container spacing={2} sx={{ pl: 4, pr: 5 }} >

        {/* Region */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Region <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="region"
              id="region"
              defaultValue=""
              displayEmpty
              name="region"
              value={region}
              onChange={handleRegionChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Region</MenuItem>
              <MenuItem value={"Matrix"}>Matrix</MenuItem>
              <MenuItem value={"Special Operations"}>Special Operations</MenuItem>
              <MenuItem value={"Apex"}>Apex</MenuItem>
              <MenuItem value={"Genesis"}>Genesis</MenuItem>
              <MenuItem value={"Maverick"}>Maverick</MenuItem>
              <MenuItem value={"Trailblazer"}>Trailblazer</MenuItem>
               <MenuItem value={"Genesis / Special Operations"}>Genesis / Special Operations</MenuItem> 
            </Select>
          </FormControl>
           {errorFields.region && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Region is required</div>
            </span>
          )}
        </Grid>

        {/* Practice */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
             Practice<span style={{ color: "red" }}>*</span></Box>
          <Autocomplete
            id="practice"
            options={practices}
            getOptionLabel={(option) => option.practiceName || ""}
            renderInput={(params) => <TextField {...params} placeholder="Select Practice" fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.practiceName === value.practiceName
            }
            value={
              practices?.filter((p) => p.practiceName === practice)[0] ||
              {}
            }
            onChange={(event, newValue) => {
              setPractice(newValue ? newValue.practiceName : "");
            }}
          />
          {errorFields.practice && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Practice is required</div>
            </span>
          )}
        </Grid>

         {/* projection date  */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Projection Date</Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="projectionDate"
              name="projectionDate"
              value={
                projectionDate ? new Date(projectionDate) : null
              }
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleProjectionDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
            />
          </LocalizationProvider>
           {/* {errorFields.projectionDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Projection Date is required</div>
            </span>
          )} */}
        </Grid>

        {/* initial go live date    */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Initial/Soft Go Live Date<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="initialGoLiveDate"
              name="initialGoLiveDate"
              value={initialGoLiveDate ? new Date(initialGoLiveDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleInitialGoLiveDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: {
                  clearable: true,
                  onClear: () => setInitialGoLiveDate(null),
                },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
            />
          </LocalizationProvider>
           {errorFields.initialGoLiveDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Initial/Soft Go live Date is required</div>
            </span>
          )}
        </Grid>

         {/* status */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Status <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="status"
              id="status"
              defaultValue=""
              displayEmpty
              name="status"
              value={status}
              onChange={handleStatusChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Status</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"Paused"}>Paused</MenuItem>
              <MenuItem value={"Discontinued"}>Discontinued</MenuItem>
              <MenuItem value={"Planned"}>Planned</MenuItem>
            </Select>
          </FormControl>
           {errorFields.status && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Status is required</div>
            </span>
          )}
        </Grid>

        {/* Modality 1  */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 1 <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality1"
            value={modality1}
            name="modality1"
            onChange={handleModality1Change}
            placeholder="Enter Modality 1"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality1 && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Modality 1 is required</div>
            </span>
          )}
        </Grid>

        {/* Modality1 Volume */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 1 Volume<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality1Volume"
            value={modality1Volume}
            name="modality1Volume"
            onChange={handleModality1VolumeChange}
            placeholder="Enter Modality 1 Volume"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality1Volume && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Modality 1 Volume is required</div>
            </span>
          )}
        </Grid>

        {/* full GoLive Date     */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Full Go Live Date<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="fullGoLiveDate"
              name="fullGoLiveDate"
              value={fullGoLiveDate ? new Date(fullGoLiveDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleFullGoLiveDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
           {errorFields.fullGoLiveDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Full Go live Date is required</div>
            </span>
          )}
        </Grid>

        {/* Modality 2 */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 2<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality2"
            value={modality2}
            name="modality2"
            onChange={handleModality2Change}
            placeholder="Enter Modality 2"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality2 && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Modality 2 is required</div>
            </span>
          )}
        </Grid>

        {/* Modality 2 Volume */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 2 Volume<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality2Volume"
            value={modality2Volume}
            name="modality2Volume"
            onChange={handleModality2VolumeChange}
            placeholder="Enter Modality 2 Volume"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality2Volume && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Modality 2 Volume is required</div>
            </span>
          )}
        </Grid>

        {/* modality 3 */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 3<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality3"
            value={modality3}
            name="modality3"
            onChange={handleModality3Change}
            placeholder="Enter  Modality 3"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality3 && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Modality 3 is required</div>
            </span>
          )}
        </Grid>

        {/* modality 3 volume */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 3 Volume<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality3Volume"
            value={modality3Volume}
            name="modality3Volume"
            onChange={handleModality3VolumeChange}
            placeholder="Enter Modality 3 Volume"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality3Volume && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Modality 3 Volume is required</div>
            </span>
          )}
        </Grid>

         {/* vra support weekdays */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            No of VRA Support Weekdays 
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="weekdaysVraSupport"
            value={weekdaysVraSupport}
            onChange={handleWeekdaysVraSupportChange}
            placeholder="Enter No of VRA Support Weekdays"
            variant="outlined"
            fullWidth
            type="number" 
          />
          
        </Grid>

        {/* vra support weekends */}

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            No of VRA Support Weekends 
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="weekendsVraSupport"
            value={weekendsVraSupport}
            onChange={handleWeekendsVraSupportChange}
            placeholder="Enter No of VRA Support Weekends"
            variant="outlined"
            fullWidth
            type="number" 
          />
         
        </Grid>

         {/* coverage start time */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 1 }}>
          <Box className="label">
            {" "}
            Coverage Duration Start Time<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={["TimePicker"]}
              style={{ overflowY: "scroll" }}
            >
              <TimePicker
                label=""
                value={coverageStart}
                sx={{ width: "100%" }}
                onChange={(newValue) => {
                  setCoverageStart(newValue);
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorFields.coverageStart && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Duration Start time is required</div>
            </span>
          )}
        </Grid>

        {/* coverage end time    */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Coverage Duration End Time<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={["TimePicker"]}
              style={{ overflowY: "scroll" }}
            >
              <TimePicker
                label=""
                value={coverageEnd}
                sx={{ width: "100%" }}
                onChange={(newValue) => {
                  setCoverageEnd(newValue);
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorFields.coverageEnd && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Coverage End time is required</div>
            </span>
          )}
        </Grid>

        {/* shift pattern */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Shift Pattern <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="shiftPattern"
            value={shiftPattern}
            onChange={handleShiftPatternChange}
            placeholder="Enter Shift Pattern"
            variant="outlined"
            fullWidth
          />
          {errorFields.shiftPattern && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Shift Pattern is required</div>
            </span>
          )}
        </Grid>

        {/* handled by Vra */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
             Handled By VH<span style={{ color: "red" }}>*</span></Box>
          <Autocomplete
            id="handled-by-vra"
            options={vraEmployees}
            getOptionLabel={(option) => option.vraFullname || ""}
            renderInput={(params) => <TextField {...params} placeholder="Select handled by VH" fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.vraRosterId === value.vraRosterId
            }
            value={
              vraEmployees?.filter((v) => v.vraRosterId === handledByVra)[0] ||
              {}
            }
            onChange={(event, newValue) => {
              setHandledByVra(newValue ? newValue.vraRosterId : "");
            }}
          />
           {errorFields.handledByVra && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Handled By VH is required</div>
            </span>
          )}
        </Grid>

        {/* handled by RP */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Handled By RP<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="handledByRp"
            value={handledByRp}
            onChange={handleHandledByRpChange}
            placeholder="Enter handled by RP"
            variant="outlined"
            fullWidth
          />
           {errorFields.handledByRp && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Handled By RP is required</div>
            </span>
          )}
        </Grid>

        {/* Remarks */}
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Remarks</Box>

          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="remarks"
            name="remarks"
            placeholder="Enter remarks"
            variant="outlined"
            fullWidth
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value.trimStart())}
            onBlur={(e) => setRemarks(e.target.value.trim())} />


        </Grid>

      </Grid>


      <Grid container sx={{ pl: 4, pr: 5, mt: 5, mb: 5, pb: 4, justifyContent: "center" }} >
        <Grid item sx={{ ml: 1 }} xs={12} sm={3} md={3} lg={3}>
          <Button className="resetChanges" onClick={handleReset}>Reset Changes</Button>
        </Grid>

        <Grid item xs={12} sm={2} md={2} lg={2}>
          <Button className="cancelButton" onClick={handleCancel}   >Cancel</Button>
        </Grid>

        <Grid item sx={{ mr: 1 }} xs={12} sm={2} md={2} lg={2}>
          <Button className="saveButton" onClick={handleSavePoolPrepRoster} >Save</Button>
        </Grid>

      </Grid>

    </div>
  )
}

export default AddPoolPrepRoster;
